<i class="icon-close close-icon clickable" (click)="cancel()"></i>

<h3 mat-dialog-title>{{ 'LABEL.LOCATION_CHANGE_TITLE' | translate }}</h3>

<p>{{ 'LOCATION_DIALOG.SUBHEADER' | translate }}</p>

<div mat-dialog-content>
    <div class="row">
        <div class="col-7">
            <app-input [label]="'CITY' | translate"
                       [(ngModel)]="location"
                       [errorStateMatcher]="matchers.location">
            </app-input>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        {{ 'BUTTON.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
        {{ 'BUTTON.SAVE' | translate }}
    </button>
</div>

